import React, {Component} from 'react';
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {Container, Row, Col, Card, CardBlock, CardFooter, Button, Input, InputGroup, InputGroupAddon} from 'reactstrap';

class Recover extends Component {
    constructor(props) {
        super(props);
        this.state = {
            status: null,
            message: null
        };
    }

    handleFormSubmit(values) {
        console.log(values);
        this.setState({status: 'loading'})
        axios.post(`/api/auth/recover`, values).then(response => {
            console.log(response)
            this.setState({status: 'success'})
        }).catch(error => {
            this.setState({status: 'error', message: error})
            console.error(error)
        });

    }

    renderError(msg) {
        return (
            <div className="alert alert-danger" role="alert">
                {msg.response.data.error.email || "Ha ocurrido un error de conexión por favor intentelo de nuevo más tarde."}
            </div>
        )
    }

    renderInput(field) {
        return <div><InputGroup className="mb-3">
            <InputGroupAddon>
                <i className="fa fa-user"></i>
            </InputGroupAddon>
            <input
                className={field.meta.touched && field.meta.error ? "form-control is-invalid" : "form-control"}
                type={field.type}
                placeholder={field.placeholder}
                disabled={field.disabled}
                {...field.input}
            />
        </InputGroup>
        </div>
    }

    renderContainer() {
        const {handleSubmit} = this.props;
        return (
            <div className="app flex-row align-items-center">
                <Container>
                    <Row className="justify-content-center">
                        <Col md="6">
                            <Card className="mx-4">
                                <CardBlock className="p-4">
                                    {this.renderForm()}
                                </CardBlock>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }
    renderForm() {
        const {handleSubmit} = this.props;
        return (
            <form onSubmit={handleSubmit(this.handleFormSubmit.bind(this))}>
                <h1>Recuperar contraseña</h1>
                <p className="text-muted">Introduzca su email para recuperar la contraseña de usuario.</p>
                {this.state.status === "error" && this.renderError(this.state.message)}
                <Field
                    name="email"
                    type="input"
                    placeholder="Email"
                    component={this.renderInput}
                />
                <Button color="success" block>Enviar</Button>
            </form>
        )
    }

    renderLoading() {
        return (
            <div className="app flex-row align-items-center">
                <Container>
                    <Row className="justify-content-center">
                        <div className="text-center"><i
                            className="text-muted fa-5x fa fa-spin fa-circle-o-notch"></i></div>
                    </Row>
                </Container>
            </div>
        )

    }

    renderSuccess() {
        return (
            <div className="app flex-row align-items-center">
                <Container>
                    <Row className="justify-content-center">
                        <div className="text-center"><i className="text-success fa fa-5x fa-check-circle-o"></i>
                            <p className="lead">Su solicitud se ha enviado</p><span className="text-muted">Le llegará una nueva contraseña a su correo, gracias.</span>
                        </div>
                    </Row>
                </Container>
            </div>
        )
    }

    render() {
        return (
            <div>
                {{
                    null: (
                        this.renderContainer()
                    ),
                    'error': (
                        this.renderContainer()
                    ),
                    'loading': (
                        this.renderLoading()
                    ),
                    'success': (
                        this.renderSuccess()
                    )
                }[this.state.status]}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        errorMessage: state.auth.error
    };
}
const validate = (values) => {
    const msg_req = "Campo requerido";
    let errors = {};
    if (!values.email || !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors.email = msg_req;
    }
    return errors;
}
Recover = reduxForm({
    form: 'recover',
    validate: validate
})(Recover);
export default Recover = connect(mapStateToProps, null)(Recover);


// WEBPACK FOOTER //
// ./resources/assets/js/components/auth/recover.jsx